module.exports = __webpack_public_path__ + "static/media/logo.e5c80c5a.png";